import React from "react";

// Design tokens for the Datails B.V. rebrand (imported from Claude Design: Datails.dc.html).
export const colors = {
  cream: "#F5F1E8",
  panel: "#ECE7DA",
  ink: "#14212B",
  footer: "#0F1A24",
  teal: "#3E8E7E",
  tealHover: "#2F6E61",
  tealDark: "#2E6155",
  tealLight: "#7FC7B8",
  border: "#E4DCCC",
  borderStrong: "#DAD0BE",
  text: "#46515B",
  textMuted: "#5A6570",
  textFaint: "#8A93A0",
};

export const serif = "'Instrument Serif', serif";
export const sans = "'Hanken Grotesk', system-ui, sans-serif";

// Shared building blocks used across pages.
export const eyebrow = {
  fontSize: 14,
  fontWeight: 600,
  letterSpacing: "0.06em",
  textTransform: "uppercase",
  color: colors.teal,
  marginBottom: 14,
};

export const container = { maxWidth: 1120, margin: "0 auto" };

export const tealButton = {
  display: "inline-flex",
  alignItems: "center",
  gap: 9,
  background: colors.teal,
  color: "#FBF7EF",
  padding: "16px 30px",
  borderRadius: 999,
  fontSize: 17,
  fontWeight: 600,
};

// Bar-chart mark used in the nav and footer.
export function Logo({ size = 24 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      style={{ display: "block", flex: "none" }}
    >
      <g transform="rotate(-40 16 16)">
        <rect x="3" y="9" width="6" height="19" rx="3" fill={colors.tealDark} />
        <rect x="13" y="5" width="6" height="23" rx="3" fill={colors.teal} />
        <rect x="23" y="2" width="6" height="26" rx="3" fill={colors.tealLight} />
      </g>
    </svg>
  );
}
